import { ClockIcon, UserIcon } from "@heroicons/react/24/outline";
import { formatDistance } from "date-fns";
import { de } from "date-fns/locale";
import type { FunctionComponent } from "react";

import { useAuth } from "~/contexts/AuthContext";
import type { InvoiceCommentWithDate } from "~/modules/billing/api/invoiceComment/invoiceCommentTypes.ts";
import { useAllUsers } from "~/modules/user/api/user/userQueries.ts";
import { nl2br } from "~/utils/stringUtils.tsx";

type Props = {
	commentData: InvoiceCommentWithDate;
	onDeleteClick?: () => void;
	onUpdateClick?: () => void;

};
const now = new Date();
const InvoiceComment: FunctionComponent<Props> = ({ commentData, onDeleteClick, onUpdateClick }) => {
	const { user } = useAuth();
	const userCanManageComment = user!.id === commentData.createdBy;
	const {
		data: usersData,
	} = useAllUsers();

	const userDisplayName = commentData.createdBy ?
		usersData?.find((user) => user.id === commentData.createdBy)?.fullName : "Unbekannt";

	const creationDate = commentData.createdAt ? formatDistance(commentData.createdAt, now, {
		addSuffix: true,
		locale: de,
	}) : "Unbekannt";

	return <div className="group relative w-full rounded-lg bg-gray-200 p-2 shadow">
		{commentData.isExcelComment &&
			<div className="mb-2 text-xs text-gray-500">Kommentar aus Excel-Liste</div>}
		{!commentData.isExcelComment && <div className="mb-2 flex items-center gap-x-2 text-xs text-gray-500">
			<div className="flex items-center gap-x-1">
				<UserIcon className="size-3" />
				{userDisplayName}
			</div>
			<div className="flex items-center gap-x-1">
				<ClockIcon className="size-3" />
				{creationDate}
			</div>
			{userCanManageComment && <div className="ml-auto flex gap-x-2">
				<button type="button"
						className="text-xs hover:underline"
						onClick={onUpdateClick}>
					Bearbeiten</button>|
				<button type="button"
						className="text-xs hover:underline"
						onClick={onDeleteClick}>
					Löschen</button>
			</div>}
		</div>}
		<div className="rounded-md bg-white p-4 text-sm">
			{nl2br(commentData.text)}
		</div>
	</div>;
};

export default InvoiceComment;